<template>
  <div>
    <div v-if="article" v-html="article.content" class="blog-post ql-editor" ></div>
  </div>
</template>

<style scoped>
.blog-post >>> img {
    max-width: 100%;
}
</style>

<script>
import {api} from 'macarons'
import 'quill/dist/quill.core.css'

export default {
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      article: null
    }
  },
  mounted () {
    api.get('blog/post/' + this.options.widget.id).then(response => {
      this.article = response.data
      this.$emit('titleChange', this.article.title)
    })
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/macarons-blog/Post.vue